import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#1c3192',
        secondary: '#757575',
        accent: '#1e88e5',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#F44336',
      },
    },
  },
});
